import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useWeb3React } from "@web3-react/core";
import {
  copyIcon,
  editIcon,
  profileCover,
  dummyProfilePic,
  walletIcon,
  DropImageIcon,
  dummyScholarProfile,
  dummyScholarCover,
} from "../../../../assets";
import { tokens } from "../../../../theme";
import styled from "@emotion/styled";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import { useAPIActions, useUIActions } from "../../../../hooks/useActions";
import { DropzoneDialog } from "mui-file-dropzone";
import fetchApi from "../../../../utils/fetch";
import { conciseAddress } from "../../../../utils/formatters";
import { SERVER_BASE_URL } from "../../../../constants";

const Header = ({
  layoutType,
  collectionCount,
  nftCount,
  name,
  address,
  coverImage,
  profileImage,
  scholarId,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account } = useWeb3React();
  const { setSnackbar, setLoading } = useUIActions();
  const { updateConnectedAccount, updateScholars } = useAPIActions();

  const { totalNfts, totalCollections, holdings, scholars } = useTypedSelector(
    (state) => state.apiReducer
  );

  const { guildName, profilePic, coverPic, _id, role } = useTypedSelector(
    (state) => state.apiReducer.connectedAccount
  );

  const [open, setOpen] = useState(false);
  const [openForCover, setOpenForCover] = useState(false);
  const [files, setFiles] = useState(false);

  const handleCloseForCover = () => {
    setOpenForCover(false);
  };

  const handleOpenForCover = () => {
    setOpenForCover(true);
  };

  const handleSaveForCover = async (file) => {
    try {
      setLoading(true);
      console.log("file", file, file[0], file[0].name, file[0].type);
      setFiles(file);

      // convertImage(file[0]);

      let blob = new Blob(file, { type: file[0].type });
      let reader = new FileReader();
      reader.onload = async function (event) {
        let dataUrl = event.target.result;
        console.log("dataUrl", dataUrl);

        const forGuild = "/registration/updateGuild";
        const forScholar = "/registration/updateScholar";
        const updateImage =
          role === "GUILD" && !address ? forGuild : forScholar;
        console.log("updateImage", updateImage);
        let bodyObj = {};
        if (role === "GUILD" && !address) {
          bodyObj = {
            _id,
            coverPic: dataUrl,
          };
        } else {
          bodyObj = {
            _id: scholarId,
            coverPic: dataUrl,
          };
        }

        let respo = await fetchApi(
          `${SERVER_BASE_URL}${updateImage}`,
          bodyObj,
          "post"
        );
        console.log("respo", respo);
        if (respo.status === 201) {
          if (role === "GUILD" && !address) {
            updateConnectedAccount({ ...respo.payload, role });
          } else {
            let updatedScholars = scholars.map((sc) => {
              if (sc._id === scholarId && sc.guildId) {
                return {
                  ...respo.payload,
                  profilePic: respo.payload.profilePic || dummyScholarProfile,
                };
              } else {
                return sc;
              }
            });
            updateScholars(updatedScholars);
          }

          setLoading(false);
          setOpenForCover(false);
        } else {
          setLoading(false);
        }
      };
      reader.readAsDataURL(blob);
    } catch (e) {
      console.log("error in saving", e);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSave = async (file) => {
    try {
      setLoading(true);
      console.log("file", file, file[0], file[0].name, file[0].type);
      setFiles(file);

      let blob = new Blob(file, { type: file[0].type });
      let reader = new FileReader();
      reader.onload = async function (event) {
        let dataUrl = event.target.result;
        console.log("dataUrl", dataUrl);
        const forGuild = "/registration/updateGuild";
        const forScholar = "/registration/updateScholar";
        const updateImage =
          role === "GUILD" && !address ? forGuild : forScholar;
        console.log("updateImage", updateImage);
        let bodyObj = {};
        if (role === "GUILD" && !address) {
          bodyObj = {
            _id,
            profilePic: dataUrl,
          };
        } else {
          bodyObj = {
            _id: scholarId,
            profilePic: dataUrl,
          };
        }
        let respo = await fetchApi(
          `${SERVER_BASE_URL}${updateImage}`,
          bodyObj,
          "post"
        );
        console.log("respo", respo);
        if (respo.status === 201) {
          if (role === "GUILD" && !address) {
            updateConnectedAccount({ ...respo.payload, role });
          } else {
            let updatedScholars = scholars.map((sc) => {
              if (sc._id === scholarId && sc.guildId) {
                return {
                  ...respo.payload,
                  coverPic: respo.payload.coverPic || dummyScholarCover,
                };
              } else {
                return sc;
              }
            });
            updateScholars(updatedScholars);
          }
          setLoading(false);
          setOpen(false);
        } else {
          setLoading(false);
        }
      };
      reader.readAsDataURL(blob);
    } catch (e) {
      console.log("error in saving", e);
      setLoading(false);
    }
  };

  console.log("opena and files", { open, files });

  return (
    <>
      <Box sx={{ width: "100%", marginBottom: "150px", paddingLeft: "20px" }}>
        <Box className="coverForTopBar">
          <Box
            sx={{
              width: "100%",
              height: "285px",
              overflow: "hidden",
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              postion: "relative",
            }}
          >
            <img
              src={coverImage || coverPic || profileCover}
              alt={"profile"}
              style={{ width: "100%" }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: -18,
                right: 0,
                width: "37px",
                height: "37px",
                borderRadius: "37px",
                backgroundColor: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => handleOpenForCover()}
            >
              <img src={editIcon} alt="edit" />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              // marginLeft: 7,
              position: "absolute",
              bottom: -120,
              width: "95%",
            }}
          >
            <Box sx={{ position: "relative" }}>
              <Box
                sx={{
                  border: "3px solid white",
                  borderRadius: "155px",
                  width: "155px",
                  height: "155px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={profileImage || profilePic || dummyProfilePic}
                  alt={"profile"}
                  style={
                    {
                      // width: "100%",
                      // height: "100%",
                      // borderRadius: "155px",
                      // border: "3px solid white",
                      // width: "155px",
                      // height: "155px",
                    }
                  }
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 5,
                  right: 9,
                  width: "37px",
                  height: "37px",
                  borderRadius: "37px",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleOpen()}
              >
                <img src={editIcon} alt="edit" />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-between",
                marginLeft: "12px",
              }}
            >
              <Typography
                variant="h3"
                color={colors.black[700]}
                fontWeight={500}
              >
                {" "}
                {name
                  ? name.length > 10
                    ? conciseAddress(name)
                    : name
                  : guildName
                  ? guildName
                  : ""}
              </Typography>
              <Stack direction="row">
                <img
                  src={walletIcon}
                  alt="copy"
                  style={{ marginRight: "5px" }}
                />
                <Typography
                  variant="subtitle2"
                  color={colors.black[700]}
                  fontWeight={400}
                >
                  {address || account || "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG"}
                </Typography>
                <img
                  src={copyIcon}
                  alt="copy"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(account);
                    setSnackbar({
                      open: true,
                      severity: "success",
                      message: `Copied!`,
                    });
                  }}
                />
              </Stack>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                marginLeft: "12px",
                width: "100%",
                height: "130px",
              }}
            >
              <Stack
                direction="row"
                visibility={collectionCount ? "visible" : "hidden"}
                display={layoutType === "tokens" ? "none" : "flex"}
              >
                <Typography
                  variant="body1"
                  color={colors.black[900]}
                  fontWeight={700}
                  marginRight="6px"
                >
                  {totalCollections}
                </Typography>
                <Typography
                  variant="body1"
                  color={colors.black[900]}
                  fontWeight={300}
                >
                  Collections
                </Typography>
              </Stack>

              <Stack
                direction="row"
                ml={"30px"}
                visibility={nftCount ? "visible" : "hidden"}
                display={layoutType === "tokens" ? "none" : "flex"}
              >
                <Typography
                  variant="body1"
                  color={colors.black[900]}
                  fontWeight={700}
                  marginRight="6px"
                >
                  {totalNfts}
                </Typography>
                <Typography
                  variant="body1"
                  color={colors.black[900]}
                  fontWeight={300}
                >
                  NFTs
                </Typography>
              </Stack>
            </Box>

            {layoutType === "tokens" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  marginLeft: "12px",
                  width: "100%",
                  height: "130px",
                }}
              >
                <Stack direction="row">
                  <Typography
                    variant="body1"
                    color={colors.black[900]}
                    fontWeight={700}
                    marginRight="6px"
                  >
                    {holdings?.length || 0}
                  </Typography>
                  <Typography
                    variant="body1"
                    color={colors.black[900]}
                    fontWeight={300}
                  >
                    Tokens
                  </Typography>
                </Stack>

                <Stack direction="row" ml={"30px"}>
                  <Typography
                    variant="body1"
                    color={colors.black[900]}
                    fontWeight={300}
                    marginRight="6px"
                  >
                    Balance
                  </Typography>
                  <Typography
                    variant="body1"
                    color={colors.black[900]}
                    fontWeight={700}
                  >
                    {holdings
                      ?.map((holding) => holding.priceInUSD)
                      .reduce((a, b) => a + b, 0)
                      .toFixed(2) || 0}
                  </Typography>
                </Stack>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <DropzoneDialog
        open={openForCover}
        onSave={handleSaveForCover}
        acceptedFiles={[
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/bmp",
          "image/svg",
        ]}
        showPreviews={false}
        maxFileSize={200000}
        onClose={handleCloseForCover}
        dialogTitle="Upload Cover Picture"
        dropzoneText=""
        filesLimit={1}
        showPreviewsInDropzone={true}
        submitButtonText="Upload"
        previewChipProps={true}
        onAdd={() => alert("added")}
        Icon={() => (
          <img
            src={DropImageIcon}
            style={{ width: "100%", height: "245px" }}
            alt="abc"
          />
        )}
        // cancelButtonText=""
        dialogProps={{
          sx: {
            "& .MuiDialog-paper": {
              // color: "red !important",
              // border: "2px solid red !important",
              display: "flex",
              alignItems: "center",
              width: "100%",
              // height: "50%",
            },
            "& .MuiBox-root": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // border: "1px solid green",
            },
            "& .MuiButton-text": {
              display: "none",
            },
            "& .MuiButton-contained": {
              width: "198px",
              height: "40px",
              marginBottom: "30px",
              backgroundColor: "#ffffff",
              border: "1px solid #6a27ea",
              color: "#6a27ea",
            },
            "& .MuiButton-contained:hover": {
              // width: "198px",
              // height: "40px",
              // marginBottom: "30px",
              backgroundColor: "#6a27ea",
              // border: "1px solid #6a27ea",
              color: "#ffffff",
            },
          },
        }}
      />

      <DropzoneDialog
        open={open}
        onSave={handleSave}
        acceptedFiles={[
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/bmp",
          "image/svg",
        ]}
        showPreviews={false}
        maxFileSize={200000}
        onClose={handleClose}
        dialogTitle="Upload Profile Picture"
        dropzoneText=""
        filesLimit={1}
        showPreviewsInDropzone={true}
        submitButtonText="Upload"
        previewChipProps={true}
        onAdd={() => alert("added")}
        Icon={() => (
          <img
            src={DropImageIcon}
            style={{ width: "100%", height: "245px" }}
            alt="abc"
          />
        )}
        // cancelButtonText=""
        dialogProps={{
          sx: {
            "& .MuiDialog-paper": {
              // color: "red !important",
              // border: "2px solid red !important",
              display: "flex",
              alignItems: "center",
              width: "100%",
              // height: "50%",
            },
            "& .MuiBox-root": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // border: "1px solid green",
            },
            "& .MuiButton-text": {
              display: "none",
            },
            "& .MuiButton-contained": {
              width: "198px",
              height: "40px",
              marginBottom: "30px",
              backgroundColor: "#ffffff",
              border: "1px solid #6a27ea",
              color: "#6a27ea",
            },
            "& .MuiButton-contained:hover": {
              // width: "198px",
              // height: "40px",
              // marginBottom: "30px",
              backgroundColor: "#6a27ea",
              // border: "1px solid #6a27ea",
              color: "#ffffff",
            },
          },
        }}
      />
      {/* {layoutType === LAYOUT_TYPES.GUILD_HUB && (
        <Stack
          direction={"row"}
          justifyContent="flex-start"
          gap="10px"
          sx={{ width: "100%", marginBottom: "10px", marginLeft: "25px" }}
        >
          <StyledButton
            onClick={() => console.log("Nft Txs")}
            variant="outlined"
            colors={colors}
            bgColor={colors.primary[500]}
            fontColor={colors.whiteAccent[900]}
            fontW={400}
            bgOnHover={colors.primary[600]}
          >
            Scholar Details
          </StyledButton>
          <StyledButton
            variant="outlined"
            colors={colors}
            bgColor={colors.whiteAccent[900]}
            fontColor={colors.primary[500]}
            fontW={500}
            bgOnHover={colors.whiteAccent[900]}
            onClick={() => console.log("crypto Txs")}
          >
            Assets Details
          </StyledButton>
        </Stack>
      )} */}
    </>
  );
};

export default Header;
